<template lang='pug'>
  div
    v-text-field(label='Webhook URL' placeholder='https://example.com/some/path' :value='value' @input='change' type='text' required :rules='required')
    div.text-body-2
      | Notification will perform an HTTP POST to the above URL. To set HTTP Headers for this POST, add them here:&nbsp;
      router-link(to='/integrations') Webhook Configuration
</template>

<script>

export default {
  name: 'WebhookUrl',
  props: {
    value: {
      type: String
    }
  },
  methods: {
    change(v) {
      this.$emit('input', v);
    }
  },
  data() {
    return {
      required: [(v) => !!v || 'Required field']
    };
  }
};
</script>

<style scoped>

</style>
